<template>
  <div class="columns mgt-20px is-multiline">
    <pose-option :societe="societe"/>
    <gestionBonAFacturer :societe="societe"></gestionBonAFacturer>
    <gestion-yield v-if="isActiveYield" :societe="societe"></gestion-yield>
    <gestion-masques :societe="societe"></gestion-masques>
    <gestion-client :societe="societe"></gestion-client>
    <gestion-regle-facturation :societe="societe"></gestion-regle-facturation>
    <gestion-indexation-commande
      v-if="moduleIndexationCommande"
      :societe="societe">
    </gestion-indexation-commande>
    <gestion-utilisateurs-echeance-negative-vente
      v-if="isActiveEcheancesAFacturerNegativesAA"
      :societe="societe"/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';
import poseOption from '@/components/parametrage/societes/ajoutEditionSociete/fonctionnement/poseOption';
import gestionBonAFacturer from '@/components/parametrage/societes/ajoutEditionSociete/fonctionnement/gestionBonAFacturer';
import gestionYield from '@/components/parametrage/societes/ajoutEditionSociete/fonctionnement/gestionYield';
import gestionClient from '@/components/parametrage/societes/ajoutEditionSociete/fonctionnement/gestionClient';
import gestionRegleFacturation from '@/components/parametrage/societes/ajoutEditionSociete/fonctionnement/gestionRegleFacturation';
import gestionIndexationCommande from '@/components/parametrage/societes/ajoutEditionSociete/fonctionnement/gestionIndexationCommande';
import gestionMasques from '@/components/parametrage/societes/ajoutEditionSociete/masque/m_gestionMasques';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import gestionUtilisateursEcheanceNegativeVente from '@/components/parametrage/societes/ajoutEditionSociete/fonctionnement/gestionUtilisateursEcheanceNegativeVente';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    societe: {
      type: Object,
      required: true,
    },
  },
  components: {
    poseOption,
    gestionBonAFacturer,
    gestionMasques,
    gestionYield,
    gestionClient,
    gestionRegleFacturation,
    gestionIndexationCommande,
    gestionUtilisateursEcheanceNegativeVente,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    isActiveYield() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.activationYield.key);
    },
    moduleIndexationCommande() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleIndexationCommande.key);
    },
    isActiveEcheancesAFacturerNegativesAA() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.echeancesAFacturerNegativesAA.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.activationYield.key,
        PARAMETRES_INTERNE_KEYS.moduleIndexationCommande.key,
        PARAMETRES_INTERNE_KEYS.echeancesAFacturerNegativesAA.key,
      ]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>
